<template>
  <v-layout justify-center align-center column>
    <!-- <v-flex> -->
    <h1>400 - Something isn't right</h1>
    <p>{{ error }}</p>
    <!-- </v-flex> -->
  </v-layout>
</template>

<script>
export default {
  name: "Error",
  data() {
    return {
      error:
        this.$route?.params?.error?.message ??
        "... try to reload the page or contact support",
    }
  },
}
</script>

<style lang="sass" scoped>
@import '@/assets/sass/globals.sass'
*
  color: $white
</style>
